export enum InspectionTemplateServiceTaskOptionTypes {
  EstimatedCost = 0,
  FileAsType = 1,
  ResponsibleParty = 2,
  DueDate = 3,
  Assignee = 4,
  SendToBoard = 5,
}

export enum InspectionTemplateServiceTaskEstimatedCostInputMethods {
  Manually = 1,
  ManuallyValidRange = 3,
  Quantity = 4,
  QuantityValidRange = 6,
  Time = 8,
  TimeValidRange = 10,
  CostsThroughPartsCatalog = 16,
}

export enum SubmitAsOptions {
  PropUpTicket = 1,
  WorkOrder = 2,
  AnyServiceTask = 3,
}

export interface DynamicTicketTypeSettingsOverride {
  dynamicTicketTypeId: number;
  apiCredentialsId: number;
  defaultOrigin: string | null;
  defaultCategoryId: number | null;
  defaultTopicId: number | null;
  availableToUserOrigins: string[];
  availableToUserCategories: number[] | null;
  availableToUserTopics: number[] | null;
}

export interface FileAsTypeServiceTaskOptionsModel {
  submitAs: SubmitAsOptions;
  defaultDynamicTicketType: number | null;
  availableToUserDynamicTicketTypes: number[];
  dynamicTicketTypeSettingsOverrides: DynamicTicketTypeSettingsOverride[];
  canSubmitMoreThanOneTicket: boolean;
  autoGeneratedTicketTitle: boolean;
  autoGeneratedTicketDescription: boolean;
  customTicketTitle: string;
  customTicketDescription: string;
  userCanEditTicketTitle?: boolean;
  userCanEditTicketDescription?: boolean;
  userInput?: boolean;
  isRequired?: boolean;
}

export interface RestInspectionTemplateServiceTaskOptionsModel {
  id: number;
  inspectionTemplateId: number;
  createdById: number;
  dateCreated: string;
  dateUpdated: string | null;
  lastModifiedById: number | null;
  optionType: InspectionTemplateServiceTaskOptionTypes;
  settingsJson: string | null;
}

export interface RestInspectionTemplateServiceTaskOptionsModelBase {
  optionType: InspectionTemplateServiceTaskOptionTypes;
  settingsJson: string | null;
}
